import useAuthorization from 'framework/authorization/authorizationService';
import { Navigation, NavigationItemType } from './types';

/**
 * Handles filtering sidebar items by user permissions.
 */
export const useSidebarPermissions = () => {
  const { isGranted } = useAuthorization();

  /**
   * Recursively filters navigation items based on user permissions.
   */
  const filterNav = (nav: Navigation): NavigationItemType[] => {
    return nav.items
      .map(item => {
        const allowed = item.permissions ? isGranted(item.permissions) : true;
        if (!allowed) return null;

        // Expose dropdown entries as ordinary children as well, so route matching and
        // the mobile sidebar use the same permission-filtered navigation tree.
        const dropdownChildren = item.thirdLevelMenuChildren
          ? filterNav({ items: item.thirdLevelMenuChildren })
          : undefined;
        if (dropdownChildren && !dropdownChildren.length) return null;

        const children = dropdownChildren ?? (item.children ? filterNav({ items: item.children }) : []);

        return { ...item, children, ...(dropdownChildren && { thirdLevelMenuChildren: dropdownChildren }) };
      })
      .filter(Boolean) as NavigationItemType[];
  };
  return { filterNav };
};
